/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'fabric.emoji.add.custom.emoji.label': '新增專屬的表情符號',
  'fabric.emoji.add.label': '新增表情符號',
  'fabric.emoji.cancel.label': '取消',
  'fabric.emoji.categories.label': '選擇表情符號類別',
  'fabric.emoji.categories.search.results': '搜尋結果',
  'fabric.emoji.category.activity': '活動',
  'fabric.emoji.category.all.uploads': '所有上傳項目',
  'fabric.emoji.category.flags': '旗標',
  'fabric.emoji.category.foods': '食物和飲料',
  'fabric.emoji.category.frequent': '常用項目',
  'fabric.emoji.category.nature': '自然',
  'fabric.emoji.category.objects': '物體',
  'fabric.emoji.category.people': '人員',
  'fabric.emoji.category.places': '旅遊和地點',
  'fabric.emoji.category.productivity': '生產力',
  'fabric.emoji.category.symbols': '符號',
  'fabric.emoji.category.user.uploads': '您的上傳項目',
  'fabric.emoji.choose.file.screenReaderDescription': '選擇表情符號的檔案。JPG、PNG 或 GIF。大小上限為 1 MB',
  'fabric.emoji.choose.file.title': '選擇檔案',
  'fabric.emoji.delete.description': '此表情符號的所有現有執行個體都將取代為 {emojiShortName}',
  'fabric.emoji.delete.label': '移除',
  'fabric.emoji.delete.screenreader.tooltip': '若要刪除 {shortName} 表情符號，請按退格鍵',
  'fabric.emoji.delete.title': '移除表情符號',
  'fabric.emoji.delete.tooltip': '刪除',
  'fabric.emoji.emojipicker.emoi.roledescription': '表情符號按鈕',
  'fabric.emoji.emojipicker.error': '錯誤！',
  'fabric.emoji.error.delete.failed': '移除失敗',
  'fabric.emoji.error.image.too.big': '所選的影像超過 1 MB',
  'fabric.emoji.error.invalid.image': '所選的影像無效',
  'fabric.emoji.error.upload.failed': '上傳失敗',
  'fabric.emoji.error.upload.timeout': '上傳逾時',
  'fabric.emoji.image.requirements': 'JPG、PNG 或 GIF。大小上限為 1 MB。',
  'fabric.emoji.name.ariaLabel': '請輸入新表情符號的名稱',
  'fabric.emoji.picker': '表情符號選取器',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {搜尋結果} other {表情符號}}',
  'fabric.emoji.pickerlist.tabpanel': '表情符號動作和列表面板',
  'fabric.emoji.placeholder': '例如您好',
  'fabric.emoji.preview': '新的表情符號 {emoji} 看起來很棒',
  'fabric.emoji.preview.title': '預覽',
  'fabric.emoji.retry.label': '重試',
  'fabric.emoji.search.label': '表情符號名稱',
  'fabric.emoji.search.placeholder': '搜尋',
  'fabric.emoji.search.status': '查看所有表情符號',
  'fabric.emoji.select.skin.list.ariaLabel': '膚色選取器',
  'fabric.emoji.select.skin.tone.ariaLabel': '選取膚色，已選取 {selectedTone}',
};
